export const THYROID_TESTS = [
  { key: "tsh", name: "TSH", unit: "mIU/L", description: "Thyroid-stimulating hormone (also known as thyrotropin, thyrotropic hormone, or abbreviated TSH) is a pituitary hormone that stimulates the thyroid gland to produce thyroxine (T4), and then triiodothyronine (T3) which stimulates the metabolism of almost every tissue in the body. It is a glycoprotein hormone produced by thyrotrope cells in the anterior pituitary gland, which regulates the endocrine function of the thyroid." },
  { key: "ft4", name: "fT4", unit: "pmol/L", description: "The major form of thyroid hormone in the blood is thyroxine (T4), whose half-life of around one week." },
  { key: "ft3", name: "fT3", unit: "pmol/L", description: "T4 is converted to the active T3 (three to four times more potent than T4) within cells by deiodinases (5\u2032-deiodinase). In humans, the ratio of T4 to T3 released into the blood is approximately 14:1." },
  { key: "atpo", name: "aTPO", unit: "kU/L", description: "Anti-thyroid peroxidase (anti-TPO) antibodies are specific for the autoantigen TPO, a 105 kDa glycoprotein that catalyses iodine oxidation and thyroglobulin tyrosyl iodination reactions in the thyroid gland." },
  { key: "tsi", name: "TSI", unit: "IU/L", description: "These antibodies (mainly IgG) act as long-acting thyroid stimulators (LATS), activating the cells through a slower and more drawn-out process compared to TSH, leading to an elevated production of thyroid hormone." },
  { key: "tg", name: "TG", unit: "mcg/L", description: "Produced by the follicular cells of the thyroid and used entirely within the thyroid gland. Thyroglobulin is in all vertebrates the main precursor to thyroid hormones, which are produced when thyroglobulin's tyrosine residues are combined with iodine and the protein is subsequently cleaved." },
  { key: "atg", name: "aTG", unit: "kU/L", description: "Anti-thyroglobulin antibodies." },
  { key: "calcitonin", name: "Calcitonin", unit: "pmol/L", description: "Calcitonin assay is used in identifying patients with nodular thyroid diseases. It is helpful in making an early diagnosis of medullary carcinoma of thyroid." }
];

export const INFLAMMATION_TESTS = [
  { key: "leucocytes", name: "Leucocytes", unit: "\u00d710\u2079/L", description: "White blood cells (WBCs) are essential for immune function. Elevated levels (>10) may indicate infection or inflammation." },
  { key: "crp", name: "CRP", unit: "mg/L", description: "C-reactive protein is an inflammation marker. Elevated CRP (>5 mg/L) may indicate acute inflammation or infection." }
];

export const BLOOD_PANEL_TESTS = [
  { key: "neutrophiles", name: "Neutrophiles", unit: "\u00d710\u2079/L", description: "Neutrophils are the most abundant type of white blood cells and form an essential part of the innate immune system." },
  { key: "lymphocytes", name: "Lymphocytes", unit: "\u00d710\u2079/L", description: "Lymphocytes are white blood cells that are part of the immune system, including T cells and B cells." },
  { key: "monocytes", name: "Monocytes", unit: "\u00d710\u2079/L", description: "Monocytes are a type of white blood cell that can differentiate into macrophages and dendritic cells." }
];

/**
 * Default questionnaire state — shared between desktop `useQuestionnaireState`
 * and mobile `MobileDashboard`. Kept in one place so future medical fields
 * only need to be added once.
 */
export const INITIAL_QUESTIONNAIRE = {
  age: "",
  gender: "",
  pregnant: "",
  pregnantWeeks: "",
  thyroidDiseasesBefore: "",
  graves: "",
  hashimoto: "",
  thyroidNodules: "",
  thyroidCancer: "",
  totalThyroidectomy: "",
  partialThyroidectomy: "",
  levothyroxin: "",
  levothyroxinDosage: "",
  levoBeforeBreakfast: "",
  levoRegularly: "",
  takesCalcium: "",
  takesIron: "",
  takesAcidReducer: "",
  levoTwoHoursApart: "",
  thiamazole: "",
  thiamazoleDosage: "",
  propylthiouracil: "",
  propylthiouracilDosage: "",
  cordarone: "",
  heartDisease: "",
  iodinatedSalt: "",
  iodineSkin: "",
  iodineSpray: "",
  ctContrast: "",
  hasFever: "",
  hasFatigue: "",
  hasNeckPain: "",
  symptomsAfterVirusInfection: "",
};
